import $ from 'jquery';
import { triggerStateChangedRequest } from '~core';
import { getState } from '~src/state';
import { clearSelectionsStyles } from '~src/utils';
import { updateTextBorderColorControl } from './updateTextBorderColorControl';
import { updateTextBorderThicknessControl } from './updateTextBorderThicknessControl';

export function onTextBorderThicknessChange(e) {
  let value = parseInt($(e.target).val());

  // Enforce min/max limits
  const min = 0;
  const max = 20;
  if (value < min) value = min;
  if (value > max) value = max;
  if (isNaN(value)) value = min;

  const activeObject = getState('activeObject');
  const saveHistory = e.type === 'change';

  // Update both controls to the clamped value
  $('#editor-text-border-thickness-slider').val(value);
  $('#editor-text-border-thickness-value').val(value);

  // Auto-set black color if thickness > 0 and no color is set
  let currentStrokeColor;
  if (activeObject.isEditing) {
    const { selectionStart, selectionEnd } = activeObject;
    if (selectionStart !== selectionEnd && selectionStart !== 0) {
      const selectionStyles = activeObject.getSelectionStyles();
      currentStrokeColor =
        selectionStyles && selectionStyles[0]
          ? selectionStyles[0]['stroke']
          : activeObject.get('stroke');
    } else {
      currentStrokeColor = activeObject.get('stroke');
    }
  } else {
    currentStrokeColor = activeObject.get('stroke');
  }

  const hasColor =
    currentStrokeColor &&
    currentStrokeColor !== 'transparent' &&
    currentStrokeColor !== null;
  const shouldAutoSetColor = value > 0 && !hasColor;

  if (activeObject.isEditing) {
    const { selectionStart, selectionEnd } = activeObject;

    if (
      activeObject.text &&
      selectionStart === 0 &&
      selectionEnd === activeObject.text.length
    ) {
      clearSelectionsStyles(activeObject, 'strokeWidth');
      activeObject.set('strokeWidth', value);
      if (shouldAutoSetColor) {
        clearSelectionsStyles(activeObject, 'stroke');
        activeObject.set('stroke', '#000000');
      }
    } else if (selectionStart === selectionEnd) {
      activeObject.set('strokeWidth', value);
      if (shouldAutoSetColor) {
        activeObject.set('stroke', '#000000');
      }
    } else {
      const updateStyles = { strokeWidth: value };
      if (shouldAutoSetColor) {
        updateStyles.stroke = '#000000';
      }
      activeObject.setSelectionStyles(updateStyles);
    }
  } else {
    clearSelectionsStyles(activeObject, 'strokeWidth');
    activeObject.set('strokeWidth', value);
    if (shouldAutoSetColor) {
      clearSelectionsStyles(activeObject, 'stroke');
      activeObject.set('stroke', '#000000');
    }
  }

  window.canvas.renderAll();
  updateTextBorderThicknessControl();
  updateTextBorderColorControl();

  if (saveHistory) {
    triggerStateChangedRequest();
  }
}
